import { atom } from 'jotai';
import { $UserPost } from 'shared/atoms';
import { $CurrentUserLinkName } from '@user/shared/current-user';

export const $CurrentUserPost = atom((get) => {
  const currentUserLinkName = get($CurrentUserLinkName);
  return get($UserPost(currentUserLinkName));
});
